"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizeFullViewportWidth = exports.sizeFullViewportHeight = exports.sizeFluid = exports.size960 = exports.size90 = exports.size880 = exports.size800 = exports.size8 = exports.size720 = exports.size70 = exports.size660 = exports.size66 = exports.size640 = exports.size60 = exports.size580 = exports.size58 = exports.size540 = exports.size500 = exports.size50 = exports.size5 = exports.size480 = exports.size48 = exports.size44 = exports.size42 = exports.size400 = exports.size40 = exports.size4 = exports.size380 = exports.size38 = exports.size36 = exports.size34 = exports.size320 = exports.size32 = exports.size300 = exports.size30 = exports.size28 = exports.size276 = exports.size260 = exports.size26 = exports.size252 = exports.size240 = exports.size24 = exports.size228 = exports.size22 = exports.size200 = exports.size20 = exports.size2 = exports.size180 = exports.size18 = exports.size160 = exports.size140 = exports.size1280 = exports.size125 = exports.size120 = exports.size12 = exports.size110 = exports.size100 = exports.size10 = void 0;
const size2 = exports.size2 = '2px';
const size4 = exports.size4 = '4px';
const size5 = exports.size5 = '5px';
const size8 = exports.size8 = '8px';
const size10 = exports.size10 = '10px';
const size12 = exports.size12 = '12px';
const size18 = exports.size18 = '18px';
const size20 = exports.size20 = '20px';
const size22 = exports.size22 = '22px';
const size24 = exports.size24 = '24px';
const size26 = exports.size26 = '26px';
const size28 = exports.size28 = '28px';
const size30 = exports.size30 = '30px';
const size32 = exports.size32 = '32px';
const size34 = exports.size34 = '34px';
const size36 = exports.size36 = '36px';
const size38 = exports.size38 = '38px';
const size40 = exports.size40 = '40px';
const size42 = exports.size42 = '42px';
const size44 = exports.size44 = '44px';
const size48 = exports.size48 = '48px';
const size50 = exports.size50 = '50px';
const size58 = exports.size58 = '58px';
const size60 = exports.size60 = '60px';
const size66 = exports.size66 = '66px';
const size70 = exports.size70 = '70px';
const size90 = exports.size90 = '90px';
const size100 = exports.size100 = '100px';
const size110 = exports.size110 = '110px';
const size120 = exports.size120 = '120px';
const size125 = exports.size125 = '125px';
const size140 = exports.size140 = '140px';
const size160 = exports.size160 = '160px';
const size180 = exports.size180 = '180px';
const size200 = exports.size200 = '200px';
const size228 = exports.size228 = '228px';
const size240 = exports.size240 = '240px';
const size252 = exports.size252 = '252px';
const size260 = exports.size260 = '260px';
const size276 = exports.size276 = '276px';
const size300 = exports.size300 = '300px';
const size320 = exports.size320 = '320px';
const size380 = exports.size380 = '380px';
const size400 = exports.size400 = '400px';
const size480 = exports.size480 = '480px';
const size500 = exports.size500 = '500px';
const size540 = exports.size540 = '540px';
const size580 = exports.size580 = '580px';
const size640 = exports.size640 = '640px';
const size660 = exports.size660 = '660px';
const size720 = exports.size720 = '720px';
const size800 = exports.size800 = '800px';
const size880 = exports.size880 = '880px';
const size960 = exports.size960 = '960px';
const size1280 = exports.size1280 = '1280px';
const sizeFluid = exports.sizeFluid = '100%';
const sizeFullViewportHeight = exports.sizeFullViewportHeight = '100vh';
const sizeFullViewportWidth = exports.sizeFullViewportWidth = '100vw';